import $ from 'jquery';

export const DEFAULT_PAGE_SIZE = 50;
export const SELECT_PAGE_SIZE = 25;
export const XERO_LEGACY_CHARGE_LINK = 'https://go.xero.com/Bank/ViewTransaction.aspx?bankTransactionID=';
export const XERO_CHARGE_LINK = 'https://go.xero.com/AccountsPayable/View.aspx?InvoiceID=';
export const XERO_RETURN_LINK = 'https://go.xero.com/AccountsPayable/ViewCreditNote.aspx?creditNoteID=';
export const XERO_INVOICE_LINK = 'https://go.xero.com/AccountsReceivable/View.aspx?InvoiceID=';
export const AMAZON_ORDER_DETAILS_LINK = 'https://www.amazon.com/gp/your-account/order-details/ref=oh_aui_or_o00_?ie=UTF8&orderID=';
export const DURATION_REGEX = /^(((\d+\.|\.)(50?|25|75|00?)?)|\d+)$/;
export const SHORT_HUMAN_DATE_FORMAT = 'M/D/YY';
export const SHORT_HUMAN_DATE_TIME_FORMAT = 'M/D/YY h:mm a';
export const SUPER_SHORT_HUMAN_DATE_FORMAT = 'M/D';
export const LONG_HUMAN_DATE_FORMAT = 'ddd, MMM Do YYYY';
export const LONG_HUMAN_DATE_TIME_FORMAT = 'ddd, MMM Do YYYY h:mm a';
export const SORTABLE_DATE_FORMAT = 'YYYY-MM-DD';
export const SORTABLE_TIME_FORMAT = 'YYYY-MM-DD-HH-mm-ss';
export const CC_DOMAIN = process.env.CC_DOMAIN;
export const SC_KEY = process.env.SC_PUBLIC_KEY;

// Select Defaults
export const ROLES = ['Praece Administrator', 'Contact', 'Praece User', 'Praece Office Admin', 'Praece System', 'Client User', 'Client Administrator', 'Praece Team Lead'];
export const PERSON_ROLES = ['Contact', 'Client User', 'Client Administrator', 'Praece User', 'Praece Office Admin', 'Praece Team Lead', 'Praece Administrator'];
export const USER_ROLES = ['Client User', 'Client Administrator', 'Praece User', 'Praece Office Admin', 'Praece Administrator', 'Praece Team Lead'];
export const CLIENT_ROLES = ['Client User', 'Client Administrator'];
export const PRAECE_ROLES = ['Praece Administrator', 'Praece User', 'Praece Team Lead', 'Praece Office Admin', 'Praece System'];
export const PRAECE_OPERATIONS_ROLES = ['Praece Administrator', 'Praece Office Admin', 'Praece System', 'Praece Team Lead'];
export const PRAECE_LEAD_ROLES = ['Praece Administrator', 'Praece System', 'Praece Team Lead'];
export const PRAECE_ADMIN_ROLES = ['Praece Administrator', 'Praece System'];
export const AUTH_SERVICES = ['analytics', 'know', 'overseer', 'vault', 'xboard', 'screenConnect', 'zabbix', 'backup', 'praeceApps'];
export const CLIENT_AUTH_SERVICES = ['vault', 'screenConnect', 'praeceApps'];
export const SUPER_USER_SERVICES = ['vault', 'screenConnect'];
export const ADMINISTRATOR_SERVICES = ['praeceApps'];
export const COMPANY_SERVICES = ['know', 'overseer', 'vault', 'xboard', 'screenConnect', 'zabbix', 'backup', 'praeceApps'];
export const ACTIVE_COMPANY_SERVICES = ['know', 'vault', 'screenConnect', 'zabbix'];
export const EXTERNAL_AUTH_ROLES = ['User', 'Super User', 'Administrator'];
export const EMAIL_TYPES = ['Work', 'Personal', 'Other'];
export const PHONE_TYPES = ['Work', 'Mobile', 'Home', 'Other'];
export const ADDRESS_TYPES = ['Office', 'PO Box', 'Home', 'Other'];
export const TICKET_TYPES = ['Help Desk', 'Project', 'Maintenance', 'Business Development', 'Internal', 'Backlog', 'Resync', 'Praece Protect'];
export const BILLING_ROLES = ['Tech', 'Team Lead', 'Consultant', 'Developer', 'Architect'];
export const INVOICE_METHODS = ['Email', 'Mail'];
export const PAYMENT_METHODS = ['ACH', 'Check'];
export const PAYMENT_STATUSES = ['Paid', 'Unpaid'];
export const STATUSES = ['Active', 'Archived'];
export const PERSON_STATUSES = ['Active', 'Disabled', 'Archived'];
export const INVOICE_STATUSES = ['Delivered', 'Not Delivered'];
export const ACH_STATUSES = ['ACH Processed', 'ACH Not Processed'];
export const TICKET_STATUSES = ['Active', 'Closed', 'Archived'];
export const TRIAGE_STATUSES = ['Active', 'Resolved', 'After Hours', 'Archived'];
export const TRIAGE_TYPES = ['Email', 'Call', 'Monitoring Alert'];
export const DEPARTMENTS = ['Technology', 'Development'];
export const BILLING_STATUSES = ['Billed', 'Not Billed'];
export const PURCHASE_ORDER_STATUSES = ['Not Fully Charged', 'Not Fully Approved', 'Complete'];

// Layout
export const width = $(window).width();
export const isMobile = width < 850;
export const isNarrowDesktop = width < 1500 && !isMobile;
export const rightPaneWidth = width < 450 ? width : 300;
export const menuWidth = isNarrowDesktop ? 82 : 200;
export const sidebarOffset = isMobile ? 0 : rightPaneWidth + menuWidth;
export const edgeThreshold = 25;
export const swipeThreshold = 25;

// States
export const STATES = [
  { value: 'AL', label: 'Alabama (AL) ' },
  { value: 'AK', label: 'Alaska (AK) ' },
  { value: 'AZ', label: 'Arizona (AZ) ' },
  { value: 'AR', label: 'Arkansas (AR) ' },
  { value: 'CA', label: 'California (CA) ' },
  { value: 'CO', label: 'Colorado (CO) ' },
  { value: 'CT', label: 'Connecticut (CT) ' },
  { value: 'DE', label: 'Delaware (DE) ' },
  { value: 'DC', label: 'District Of Columbia (DC) ' },
  { value: 'FL', label: 'Florida (FL) ' },
  { value: 'GA', label: 'Georgia (GA) ' },
  { value: 'HI', label: 'Hawaii (HI) ' },
  { value: 'ID', label: 'Idaho (ID) ' },
  { value: 'IL', label: 'Illinois (IL) ' },
  { value: 'IN', label: 'Indiana (IN) ' },
  { value: 'IA', label: 'Iowa (IA) ' },
  { value: 'KS', label: 'Kansas (KS) ' },
  { value: 'KY', label: 'Kentucky (KY) ' },
  { value: 'LA', label: 'Louisiana (LA) ' },
  { value: 'ME', label: 'Maine (ME) ' },
  { value: 'MD', label: 'Maryland (MD) ' },
  { value: 'MA', label: 'Massachusetts (MA) ' },
  { value: 'MI', label: 'Michigan (MI) ' },
  { value: 'MN', label: 'Minnesota (MN) ' },
  { value: 'MS', label: 'Mississippi (MS) ' },
  { value: 'MO', label: 'Missouri (MO) ' },
  { value: 'MT', label: 'Montana (MT) ' },
  { value: 'NE', label: 'Nebraska (NE) ' },
  { value: 'NV', label: 'Nevada (NV) ' },
  { value: 'NH', label: 'New Hampshire (NH) ' },
  { value: 'NJ', label: 'New Jersey (NJ) ' },
  { value: 'NM', label: 'New Mexico (NM) ' },
  { value: 'NY', label: 'New York (NY) ' },
  { value: 'NC', label: 'North Carolina (NC) ' },
  { value: 'ND', label: 'North Dakota (ND) ' },
  { value: 'OH', label: 'Ohio (OH) ' },
  { value: 'OK', label: 'Oklahoma (OK) ' },
  { value: 'OR', label: 'Oregon (OR) ' },
  { value: 'PA', label: 'Pennsylvania (PA) ' },
  { value: 'RI', label: 'Rhode Island (RI) ' },
  { value: 'SC', label: 'South Carolina (SC) ' },
  { value: 'SD', label: 'South Dakota (SD) ' },
  { value: 'TN', label: 'Tennessee (TN) ' },
  { value: 'TX', label: 'Texas (TX) ' },
  { value: 'UT', label: 'Utah (UT) ' },
  { value: 'VT', label: 'Vermont (VT) ' },
  { value: 'VA', label: 'Virginia (VA) ' },
  { value: 'WA', label: 'Washington (WA) ' },
  { value: 'WV', label: 'West Virginia (WV) ' },
  { value: 'WI', label: 'Wisconsin (WI) ' },
  { value: 'WY', label: 'Wyoming (WY)' }
];

export const DAYSOFWEEK = [
  { label: 'Sunday', value: '0' },
  { label: 'Monday', value: '1' },
  { label: 'Tuesday', value: '2' },
  { label: 'Wednesday', value: '3' },
  { label: 'Thursday', value: '4' },
  { label: 'Friday', value: '5' },
  { label: 'Saturday', value: '6' }
];

export const MONTHS = [
  { label: 'January', value: '0' },
  { label: 'February', value: '1' },
  { label: 'March', value: '2' },
  { label: 'April', value: '3' },
  { label: 'May', value: '4' },
  { label: 'June', value: '5' },
  { label: 'July', value: '6' },
  { label: 'August', value: '7' },
  { label: 'September', value: '8' },
  { label: 'October', value: '9' },
  { label: 'November', value: '10' },
  { label: 'December', value: '11' }
];




// WEBPACK FOOTER //
// ./app/constants.js